import React from 'react';

const InboxPageConfig: any = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	routes: [
		{
			path: '/admin/home/inbox',
			exact: true,
			component: React.lazy(() => import('./InboxPage')),
		},
	],
};

export default InboxPageConfig;
